import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  ChangeDetectorRef,
  AfterViewInit,
  HostListener,
  ElementRef,
  Renderer2,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import $ from 'jquery';
import { SortingDialogComponent } from 'src/app/main/sorting-dialog/sorting-dialog.component';
import { ResizeEvent } from 'angular-resizable-element';
import { MatSelect } from '@angular/material/select';
import { FilterSearchOptions } from 'src/app/_constant/dynamic-search-option.const';
import moment from 'moment';

import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { LoggedonUserComponent } from '../account-managment/loggedon-user/loggedon-user.component';
import { UserDialogComponent } from './user-dialog/user-dialog.component';
import { ToolbarServiceService } from 'src/app/layout/components/toolbar/toolbar-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TimersService } from '@_services/timers.service';
import { TableColumnsService } from '@_services/table-columns.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { BehaviorService } from '@_services/Behavior.service';
import { SortingBehaviourService } from '@_services/sorting-behaviour.service';
import { HyperlinkNavigationService } from '@_services/hyperlink-navigation.service';
import { Subject, takeUntil } from 'rxjs';
import { TierPermissionPipe } from '@_pipes/tier-permission.pipe';
import { MatMenuTrigger } from '@angular/material/menu';
import { FuseConfirmDialogComponent } from '@/app/Shared/confirm-dialog/confirm-dialog.component';
import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [TierPermissionPipe],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsersComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatTable, { read: ElementRef }) private matTableRef: ElementRef;
  userfilter: FormGroup;
  hasSearchVal: boolean = false;
  disabledMainMenuTrigger: boolean = true;
  @ViewChild('menu', { static: false }) menu: MatMenuTrigger;
  @ViewChild('searchField', { static: false })
  searchField: ElementRef<HTMLInputElement>;
  appPermissions: any = JSON.parse(localStorage.getItem('app_permissions')!);
  isLoadingResults: boolean = false;
  displayedColumns: string[];
  columnsObj: any = [];
  tempColobj: any;
  theme_type: string | null = localStorage.getItem('theme_type');
  selectedColore: string = 'var(--highlighted-bg-row)';
  Userid: string = this.theme_type == 'theme-default' ? 'Solicitor' : 'Client';
  highlightedRows: any;
  currentUserData: any;
  pageSize: any;
  Useralldata: any = [];
  lastFilter: any;
  isDisplay: boolean = false;
  sortingDefaultState: any = {};
  sortactive: any;
  sortDirection: any;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  userList: any;
  totalApplicableFilterCount: number = 0;
  optionalFilterList: any[] = [];
  activeFilters: any;
  currentUser: any = JSON.parse(localStorage.getItem('currentUser')!);
  permissionSsoDesc: any = JSON.parse(window.localStorage.getItem('set_tier_permission')!);
  login_data: any = JSON.parse(localStorage.getItem('login_data')!);
  FILTERS: FormArray;
  FILTERSLIST: FormArray;
  _filterList: any[] = [];
  showFiltersList: boolean = true;
  saveAdvanceFilter: any[] = [];
  optionalDateFilterPayload: any[] = [];
  optionalFilters: any[] = [];
  activeOptionalFilter: any;
  selectedFilterIs: any;
  addFilter: any;
  clearFilters: boolean = false;
  oldIsTrackId: any;
  activeFilterdata = [
    {
      name: 'All Users',
      id: '',
    },
    {
      name: 'Active Users',
      id: '1',
    },
    {
      name: 'Inactive Users',
      id: '0',
    },
  ];
  currentMenu: any = null;
  isLoadingResult: boolean = false;
  COLOR: any;
  resizableMousemove: () => void;
  resizableMouseup: () => void;

  isUserData: any;
  confirmDialogRef: MatDialogRef<any>;
  CurrentDate: any;
  openWebsite: any;
  private _unsubscribeAll$: Subject<void> = new Subject();
  constructor(
    private _formBuilder: FormBuilder,
    private Timersservice: TimersService,
    private TableColumnsService: TableColumnsService,
    private _mainAPiServiceService: MainAPiServiceService,
    private toastr: ToastrService,
    private behaviorService: BehaviorService,
    private SortingbehaviorService: SortingBehaviourService,
    private cdf: ChangeDetectorRef,
    private router: Router,
    private location: Location,
    private hyperlink: HyperlinkNavigationService,
    public toolbarServiceService: ToolbarServiceService,
    public _matDialog: MatDialog,
    private tierpermission: TierPermissionPipe,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer,
  ) {
    this.hyperlink.setColorSetting();
    this.behaviorService.ColorSystemSetting$.pipe(takeUntil(this._unsubscribeAll$)).subscribe({
      next: (data: any) => {
        this.COLOR = data;
        this.cdf.markForCheck();
      },
    });

    this.behaviorService.loadingUserMenuResult$.pipe(takeUntil(this._unsubscribeAll$)).subscribe({
      next: (data: any) => {
        this.isLoadingResult = data;
        this.cdf.markForCheck();
      },
    });
    this.behaviorService.UserData$.pipe(takeUntil(this._unsubscribeAll$)).subscribe({
      next: (result: any) => {
        if (result) {
          this.isUserData = 'Notempty';
        } else {
          this.isUserData = 'empty';
        }
        this.cdf.markForCheck();
      },
    });
    localStorage.setItem('istrackid', 'UserScreenComponent');
    this.SortingbehaviorService.userScreenSorting$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (result: any) => {
          if (result) {
            this.sortingDefaultState = result;
            localStorage.setItem('user_screen_sorting', JSON.stringify(result));
          } else {
            this.sortingDefaultState = JSON.parse(localStorage.getItem('user_screen_sorting')!);
          }
          this.cdf.markForCheck();
        },
      });
    this.SortingbehaviorService.UserFilterData$.pipe(takeUntil(this._unsubscribeAll$)).subscribe({
      next: (result: any) => {
        if (result) {
          localStorage.setItem('users_filter', JSON.stringify(result));
        }
        this.cdf.markForCheck();
      },
    });
    // let filterData = JSON.parse(localStorage.getItem('users_filter'));
    if (localStorage.getItem('users_filter')) {
      this.lastFilter = JSON.parse(localStorage.getItem('users_filter')!);
    } else {
      this.lastFilter = {
        Filters: { ACTIVE: '', AllData: false, Search: '' },
      };
      localStorage.setItem('users_filter', JSON.stringify(this.lastFilter));
    }
    this.userfilter = this._formBuilder.group({
      ACTIVE: [this.lastFilter.ACTIVE],
      FILTERS: new FormArray([]),
      FILTERSLIST: new FormArray([]),
      MAINFILTER: [''],
      searchFilter: [''],
    });

    this.behaviorService.APIretryCall$.pipe(takeUntil(this._unsubscribeAll$)).subscribe({
      next: (result: any) => {
        if (
          localStorage.getItem('istrackid') == 'UserScreenComponent' &&
          result['click'] &&
          result['data']['user']
        ) {
          if (!localStorage.getItem('user_list_columns')) {
            this.getTableFilter();
            this.getFilter();
          }
          this.lastFilter = JSON.parse(localStorage.getItem('users_filter')!);
          const advanceFilterPayload: any =
            this.TableColumnsService.loadAdvanceFilterPayload('Users');

          // this.filterVals.AdvancedFilters = advanceFilterPayload ;
          if (
            advanceFilterPayload == '' ||
            advanceFilterPayload == undefined ||
            advanceFilterPayload == null
          ) {
            delete this.lastFilter.AdvancedFilters;
          } else {
            this.lastFilter.AdvancedFilters = advanceFilterPayload;
          }

          this.loadData(this.lastFilter);
        }
        this.cdf.markForCheck();
      },
    });

    this.addFilter = {
      OPERATION: '',
      VALUE: '',
      VALUE2: '',
      FILTERTYPE: '',
    };
    this.behaviorService.usersMenu$.pipe(takeUntil(this._unsubscribeAll$)).subscribe({
      next: (data: any) => {
        this.currentMenu = data;
        this.cdf.markForCheck();
      },
    });
    this.behaviorService.setUserMenuName(null);
  }
  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    if (this.sortingDefaultState) {
      this.sortactive = this.sortingDefaultState.active;
      this.sortDirection = this.sortingDefaultState.direction;
    } else {
      this.sortactive = '';
      this.sortDirection = '';
    }
    this.behaviorService.resizeTableForAllView();
    const behaviorService = this.behaviorService;
    $(window).resize(function () {
      behaviorService.resizeTableForAllView();
    });
    this.getTableFilter();
    this.getFilter();
    // this.loadData(this.lastFilter);
    const advanceFilterPayload = this.TableColumnsService.loadAdvanceFilterPayload('Users');

    // this.filterVals.AdvancedFilters = advanceFilterPayload ;
    if (
      advanceFilterPayload == '' ||
      advanceFilterPayload == undefined ||
      advanceFilterPayload == null
    ) {
      delete this.lastFilter.AdvancedFilters;
    } else {
      this.lastFilter.AdvancedFilters = advanceFilterPayload;
    }
    this.setDefaultAdvanceFilter();
    this.loadData(this.lastFilter);
    this.nameFunction();
    this.behaviorService.loadingSystemSetting$.next(true);
    this.behaviorService.SystemSettingUserTab$.next({
      menu: 'users',
    });
  }

  /**
   * It runs only once after the component's view has been rendered.
   */
  ngAfterViewInit(): void {
    this.TableColumnsService.setTableResize(this.matTableRef.nativeElement.clientWidth);
  }

  DownloadAllData() {}

  downloadFile() {
    const sortedData = this.Useralldata.sortData(
      this.Useralldata.filteredData,
      this.Useralldata.sort,
    );
    this.TableColumnsService.exportDataIntoCsv(
      this.displayedColumns,
      sortedData,
      'Userall_data_',
      this.tempColobj,
    );
  }

  ngAfterContentChecked() {
    this.behaviorService.resizeTableForAllView();
  }

  sortData(val: any) {
    this.SortingbehaviorService.userScreenSorting(val);
    this.setDefaultWidth(this.displayedColumns, 0);
  }
  getTableFilter() {
    let userListColumns: any = JSON.parse(localStorage.getItem('user_list_columns')!);
    if (userListColumns && userListColumns != null) {
      let data: any = this.TableColumnsService.filtertableColum((userListColumns.columnsObj ?? userListColumns['ColumnsObj']));
      this.displayedColumns = userListColumns.displayedColumns;
      this.tempColobj = data.tempColobj;
      this.columnsObj = (userListColumns.columnsObj ?? userListColumns['ColumnsObj']);
      this.cdf.markForCheck();
    } else {
      this.TableColumnsService.getTableFilter('Users', '')
        .pipe(takeUntil(this._unsubscribeAll$))
        .subscribe({
          next: (response: any) => {
            if (response.CODE == 200 && response.STATUS == 'success') {
              let data: any = this.TableColumnsService.filtertableColum(response.DATA.RECORDS);
              this.displayedColumns = data.showcol;
              this.tempColobj = data.tempColobj;
              this.columnsObj = data.colobj;
              localStorage.setItem(
                'user_list_columns',
                JSON.stringify({
                  columnsObj: data.colobj,
                  displayedColumns: data.showcol,
                }),
              );
            }
            this.cdf.markForCheck();
          },
          error: (error: any) => {
            this.toastr.error(error);
            this.cdf.markForCheck();
          },
        });
    }
  }
  onResizing(event: ResizeEvent, columnName: any): void {
    if (event.edges.right) {
      const cssValue = event.rectangle.width + 'px';
      const columnElts = document.getElementsByClassName('mat-column-' + columnName);
      for (let i = 0; i < columnElts.length; i++) {
        const currentEl = columnElts[i] as HTMLDivElement;
        currentEl.style.width = cssValue;
      }
      const indexData = this.columnsObj.findIndex((col: any) => col.COLUMNID === columnName);
      this.columnsObj[indexData]['WIDTH'] = event.rectangle.width;
      localStorage.setItem(
        'user_list_columns',
        JSON.stringify({
          columnsObj: this.columnsObj,
          displayedColumns: this.displayedColumns,
        }),
      );
      this.cdf.markForCheck();
    }
  }
  onResizeEnd(event: ResizeEvent, columnName: any): void {
    this.TableColumnsService.SaveWidthData(this.columnsObj, 'Users', '');
  }

  //For resize this fuction is most impotent don't make it comman it's give issue in future.
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.TableColumnsService.setTableResize(this.matTableRef.nativeElement.clientWidth);
  }

  /**
   * This function is used to set the default width
   */
  setDefaultWidth(displayedColumns: any, timeout: any) {
    setTimeout(() => {
      displayedColumns?.forEach((element: any) => {
        let temWidth = this.tempColobj[element]['WIDTH'];
        const cssValue = temWidth + 'px';
        const columnElts = document.getElementsByClassName('mat-column-' + element);
        for (let i = 0; i < columnElts.length; i++) {
          const currentEl = columnElts[i] as HTMLDivElement;
          currentEl.style.visibility = 'inherit';
          currentEl.style.width = cssValue;
        }
      });
      this.cdf.markForCheck();
    }, timeout);
  }

  /**
   * This function is used to change the user type
   */
  UserTypeChange(event: any) {
    this.lastFilter.Filters.ACTIVE = event.value;
    localStorage.setItem('users_filter', JSON.stringify(this.lastFilter));
    const advanceFilterPayload: any = this.TableColumnsService.loadAdvanceFilterPayload('Users');
    // this.filterVals.AdvancedFilters = advanceFilterPayload ;
    if (
      advanceFilterPayload == '' ||
      advanceFilterPayload == undefined ||
      advanceFilterPayload == null
    ) {
      delete this.lastFilter.AdvancedFilters;
    } else {
      this.lastFilter.AdvancedFilters = advanceFilterPayload;
    }

    this.loadData(this.lastFilter);
  }

  /**
   * This function is used to refresh data
   */
  refreshData() {
    this.loadData(this.lastFilter);
  }

  /**
   * This function is used to on pagination change
   */
  onPaginateChange(event: any) {
    this.setDefaultWidth(this.displayedColumns, 0);
    this.pageSize.user_page = event.pageSize;
    localStorage.setItem('lastPageSize', JSON.stringify(this.pageSize));
    this.cdf.markForCheck();
  }

  /**
   * This function is used to set the active user data.
   */
  setActiveUserData(rowData: any) {
    localStorage.setItem('current_user_Data', JSON.stringify(rowData));
    this.behaviorService.UserData(rowData);
  }

  /**
   * This function is used to load the data value
   */
  loadData(filterData: any) {
    this.SortingbehaviorService.SetUserFilterData(filterData);
    this.isLoadingResults = true;
    this.cdf.markForCheck();

    filterData.Filters.AllData = true;
    //filterData.Filters.ACTIVE = (filterData.ACTIVE)?filterData.ACTIVE: 1;
    filterData.Action = 'GetData';

    delete filterData.AllData;
    delete filterData.ACTIVE;

    this._mainAPiServiceService
      .getSetData(filterData, 'user')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (
            response.CODE === 200 &&
            (response.STATUS === 'OK' || response.STATUS === 'success')
          ) {
            if (response.DATA.USERS[0]) {
              this.isDisplay = false;
              this.highlightedRows = response.DATA.USERS[0].USERGUID;
              this.currentUserData = response.DATA.USERS[0];
              this.setActiveUserData(response.DATA.USERS[0]);
            } else {
              this.isDisplay = true;
            }
            this.Useralldata = new MatTableDataSource(response.DATA.USERS);
            this.Useralldata.paginator = this.paginator;
            this.Useralldata.sort = this.sort;
            this.setDefaultWidth(this.displayedColumns, 500);
            this.cdf.detectChanges();
          }
          this.isLoadingResults = false;
          this.cdf.markForCheck();
        },
        error: (error: any) => {
          this.toastr.error(error);
          this.isLoadingResults = false;
          this.cdf.markForCheck();
        },
      });
    this.GetFeeEarnerList();
    this.pageSize = JSON.parse(localStorage.getItem('lastPageSize')!);
  }

  /**
   * THis function is used to open the dialog
   */
  openDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '800px';
    dialogConfig.disableClose = true;
    dialogConfig.data = { data: this.columnsObj, type: 'Users', list: '' };
    //open pop-up
    const dialogRef = this._matDialog.open(SortingDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          this.displayedColumns = result.columObj;
          this.columnsObj = result.columnameObj;
          this.tempColobj = result.tempColobj;
          localStorage.setItem(
            'user_list_columns',
            JSON.stringify({
              displayedColumns: result.columObj,
              columnsObj: result.columnameObj,
            }),
          );
          if (!result.columObj) {
            this.Useralldata = new MatTableDataSource([]);
            this.Useralldata.paginator = this.paginator;
            this.Useralldata.sort = this.sort;
            this.isDisplay = true;
          } else {
            this.loadData(this.lastFilter);
          }
        }
        this.cdf.markForCheck();
      },
    });
  }

  /**
   * This function is used to get the fee Earner List
   */
  GetFeeEarnerList() {
    if (!JSON.parse(localStorage.getItem('users_list')!)) {
      this.Timersservice.GetUsers({})
        .pipe(takeUntil(this._unsubscribeAll$))
        .subscribe({
          next: (res: any) => {
            if (res.CODE == 200 && res.STATUS == 'success') {
              this.userList = this.Timersservice.removeUSerWithoutId(res.DATA.USERS);
              localStorage.setItem('users_list', JSON.stringify(res.DATA.USERS));
            } else {
              this.userList = [];
            }
            this.cdf.markForCheck();
          },
          error: (err: any) => {
            this.toastr.error(err);
            this.cdf.markForCheck();
          },
        });
    }
  }

  doubleClick(event: any) {
    $('#editUserBtn').click();
  }

  /**
   * this function is used to get the filter data.
   */
  getFilter(): void {
    let opFilterList: any = JSON.parse(localStorage.getItem('user_list_columns')!);
    const filterData: any = this.TableColumnsService.getDynamicFilter(
      opFilterList,
      this.optionalFilterList,
      'user_list_columns',
    );
    this.defaultSetFilter();
    this.refreshFilterList();
    this.cdf.markForCheck();
  }

  /**
   * This function is used to set the default filter data.
   */
  defaultSetFilter() {
    if (JSON.parse(localStorage.getItem('Users_config')!)) {
      this.activeFilters = JSON.parse(localStorage.getItem('Users_config')!);
      //  this.activeFilters.active = this.filterVals.active;
      if (this.lastFilter.ACTIVE == 1) {
        this.activeFilters.activeDesc = 'Active Users';
        this.activeFilters.active = this.f.ACTIVE.value;
      }
      if (this.lastFilter.ACTIVE == 0) {
        this.activeFilters.activeDesc = 'Inactive Users';
        this.activeFilters.active = this.f.ACTIVE.value;
      }
      if (this.lastFilter.ACTIVE == '' || this.lastFilter.active == '') {
        this.activeFilters.activeDesc = 'All Users';
      }
      if (this.lastFilter.ACTIVE == 'All Users') {
        this.activeFilters.activeDesc = 'All Users';
        this.activeFilters.active = ' ';
      }
      this.activeFilters.Search = this.f.searchFilter.value;
    } else {
      this.activeFilters = {};
      // this.activeFilters.active = this.f.active.value;
      // this.activeFilters.contactType = this.f.ContactType.value;
      // this.activeFilters.firstLetter = this.f.FirstLetter.value;
      // this.activeFilters.Search = this.f.search.value;

      if (this.lastFilter.ACTIVE == 1 || !this.lastFilter.ACTIVE) {
        this.activeFilters.activeDesc = 'All Users';
        this.userfilter.controls['ACTIVE'].setValue('');
        this.activeFilters.active = this.f.ACTIVE.value;
      }
      if (this.lastFilter.ACTIVE == 0) {
        this.activeFilters.activeDesc = 'Inactive Users';
        this.activeFilters.active = this.f.ACTIVE.value;
      }
      if (this.lastFilter.ACTIVE == '') {
        this.activeFilters.activeDesc = 'All Users';
        this.activeFilters.active = this.f.ACTIVE.value;
      }
      if (this.lastFilter.ACTIVE == 'All Users') {
        this.activeFilters.activeDesc = 'All Users';
        this.activeFilters.active = '';
      }
      if (this.lastFilter.ACTIVE == '' && this.lastFilter.AllData == false) {
        this.activeFilters.activeDesc = 'All Users';
        this.activeFilters.active = '';
        this.activeFilters.active = this.f.ACTIVE.value;
      }
      this.activeFilters.Search = this.f.searchFilter.value;
    }
    this.cdf.markForCheck();
  }

  /**
   * This function is used to refresh the filter list.
   */
  refreshFilterList(): void {
    this.totalApplicableFilterCount = 0;
    const advDynamicFilter: any = JSON.parse(localStorage.getItem('Users_Advance_Filter')!);
    this.optionalFilterList.map((x: any) => {
      if (x.FILTERTYPE != 'HIDDEN') {
        this.totalApplicableFilterCount += 1;
      }

      if (
        advDynamicFilter &&
        advDynamicFilter.findIndex((e: any) => e.COLUMNID == x.COLUMNID) !== -1
      ) {
        x.FILTERAPPLY = true;
      }
    });
    this.cdf.markForCheck();
  }

  get f() {
    return this.userfilter.controls;
  }

  /**
   * This function is used to back to the filter ui.
   * @param id -filter id
   */
  backToFilter(id: any) {
    $('#' + id).removeClass('active');
    setTimeout(() => {
      $('.mat-menu-content').removeClass('active');
      $('.mat-menu-content').removeClass('mat-menu-content_height');
      this.cdf.markForCheck();
    }, 50);

    if (this.FILTERS) {
      this.FILTERSLIST = this.userfilter.get('FILTERSLIST') as FormArray;
      this.FILTERSLIST.reset();
    }
    this.cdf.markForCheck();
  }

  /**
   * This function is used to reset the filter
   */
  resetFilter(): void {
    // reset FILTERAPPLY value
    this.optionalFilterList.forEach((filter: any, index: any) => {
      filter.FILTERAPPLY = false;
    });

    let resetFilter: any = JSON.parse(localStorage.getItem('users_filter')!);
    localStorage.removeItem('Users_Advance_Filter');
    this.saveAdvanceFilter = [];
    this.userfilter.patchValue({
      ACTIVE:
        resetFilter.ACTIVE == '' || resetFilter.ACTIVE == 'All Users' || resetFilter.ACTIVE == 'all'
          ? ''
          : resetFilter.ACTIVE,
    });
    this.optionalFilters = [];
    this.optionalDateFilterPayload = [];
    if (this.FILTERS) {
      this.FILTERS.reset();
      // this.FILTERSLIST.reset();
    }

    setTimeout(() => {
      this.activeFilters = {};
      if (resetFilter.ACTIVE == 1) {
        this.activeFilters.activeDesc = 'Active Users';
        this.activeFilters.active = resetFilter.ACTIVE;
      }
      if (resetFilter.ACTIVE == 0) {
        this.activeFilters.activeDesc = 'Inactive Users';
        this.activeFilters.active = resetFilter.ACTIVE;
      }
      if (resetFilter.ACTIVE == 'all' || resetFilter.ACTIVE == '') {
        this.activeFilters.activeDesc = 'All Users';
        this.activeFilters.active = resetFilter.active;
      }
      if (resetFilter.ACTIVE == 'All Users') {
        this.activeFilters.activeDesc = 'All Users';
        this.activeFilters.active = ' ';
        resetFilter.ACTIVE = '';
      }
      this.activeFilters.Search = '';
      localStorage.setItem('users_filter', JSON.stringify(resetFilter));
      if (resetFilter.AdvancedFilters) {
        delete resetFilter.AdvancedFilters;
      }

      this.loadData(resetFilter);
      this.cdf.markForCheck();
    }, 500);
    this.cdf.markForCheck();
  }

  /**
   * This function is used to refresh the user tab data
   * @param isAllData -isAlldata
   */
  refreshUserTab(isAllData: any): void {
    this.lastFilter = JSON.parse(localStorage.getItem('users_filter')!);

    // this.LoadData(this.filterVals);
    this.addOptionalFilter(this.lastFilter);
    localStorage.setItem('users_filter', JSON.stringify(this.lastFilter));
    this.cdf.markForCheck();
  }

  /**
   * This function is used to on search change
   */
  onSearchChange(searchFilter: any) {
    if (searchFilter['key'] === 'Enter') {
      this.onFilterSearch('Enter');
    }
  }

  /**
   * This function is used to set the focus
   */
  setFocus(fieldRefVar: any) {
    this.searchField.nativeElement.focus();
  }

  /**
   * This function is used to on filter search
   */
  onFilterSearch(searchFilter?: any) {
    if (this.userfilter.value['searchFilter'] || this.userfilter.value['searchFilter'] == '') {
      //able to remove search filter
      if (searchFilter == 'removeSearchString') {
        this.userfilter.controls['searchFilter'].setValue('');
      }
      let filterVal: any = {
        Filters: {
          ACTIVE: '',
          AllData: true,
          Search: this.f.searchFilter.value,
        },
      };
      if (!localStorage.getItem('users_filter')) {
        localStorage.setItem('users_filter', JSON.stringify(filterVal));
      } else {
        filterVal = JSON.parse(localStorage.getItem('users_filter')!);
        filterVal.Filters.Search = this.f.searchFilter.value;
        localStorage.setItem('users_filter', JSON.stringify(filterVal));
      }
      this.hasSearchVal = filterVal.Filters.Search ? true : false;

      this.addOptionalFilter(null); // add the optional filters.
      this.cdf.markForCheck();
    }
  }

  /**
   * This function is used to add optional filter data.
   * @param prevFilter -data of the filter
   */
  addOptionalFilter(prevFilter?: any) {
    //Delete Filters
    const Filter: any = prevFilter
      ? JSON.parse(JSON.stringify(prevFilter))
      : JSON.parse(localStorage.getItem('users_filter')!);
    delete Filter.activeDesc;
    delete Filter.unbilledWorkDesc;
    delete Filter.FILTERINDEX;
    delete Filter.FILTERAPPLAY;
    const ArrayResetOptional: any = JSON.parse(JSON.stringify(this.userfilter.value.FILTERS));
    const finalPayload: any = ArrayResetOptional.filter(
      (d: any) => d['VALUE'] !== null && d['VALUE'] !== '',
    ).map((e: any) => {
      if (e['VALUE'] && e['VALUE'] !== '') {
        delete e.COLUMNID;
        return e;
      }
    });

    Filter.AdvancedFilters = finalPayload;
    if ((this.FILTERS && this.FILTERS.controls.length == 0) || finalPayload.length == 0) {
      delete Filter.AdvancedFilters;
    }
    this.reload(Filter);
  }

  /**
   * This function is used to load the user data (refresh)
   * @param filterVal -current applied filter data.
   */
  reload(filterVal: any): void {
    this.loadData(filterVal);
  }

  /**
   * This function is used to get the preventdefault data value.
   * @param event -event data
   */
  preventDefault(event: any): void {
    event.preventDefault();
    event.stopPropagation();
  }

  /**
   * This function is used to get the Active current filter data
   * @param id -filter id
   * @param data -data of the filter.
   */
  activeCurrentFilter(id: any, data?: any) {
    $('#' + id).addClass('active');
    setTimeout(() => {
      $('.mat-menu-content').addClass('active');
      $('.mat-menu-content').addClass('mat-menu-content_height');
      this.cdf.markForCheck();
    }, 200);

    this.selectedFilterIs = '';
    this.activeOptionalFilter = data;
    this.userfilter.controls['MAINFILTER'].reset();
    this.cdf.markForCheck();
  }
  @ViewChild('operationFilter', { static: false }) operationFilter: MatSelect;
  activeFilter = FilterSearchOptions.activeFilter;

  unbuildWorkFilter = FilterSearchOptions.unbuildWorkFilter;

  dateFilter = FilterSearchOptions.dateFilter;

  currencyFilter = FilterSearchOptions.currencyFilter;

  manullyOptionalFilter = FilterSearchOptions.manuallyOptionalFilter;

  /**
   * This function is used to Add the new filter data.
   * @param event -event data.
   */
  addNewFilter(event: any) {
    setTimeout(() => {
      this.operationFilter.options.first.select();
      this.cdf.markForCheck();
    }, 200);
    if (this.FILTERSLIST) {
      this.FILTERSLIST.controls.splice(0, 1);
    }

    if (event.FILTERTYPE == 'DATE') {
      event.DATEFILTERLIST = this.dateFilter;
      event.DATEINNETFILTER = [
        {
          id: 1,
          value: 'days',
        },
        {
          id: 2,
          value: 'months',
        },
      ];
    }

    if (
      event.FILTERTYPE !== 'DATE' &&
      event.FILTERTYPE !== 'CURRENCY' &&
      event.FILTERTYPE !== 'NUMBER'
    ) {
      event.DATEFILTERLIST = this.manullyOptionalFilter;
    }

    if (event.FILTERTYPE == 'CURRENCY' || event.FILTERTYPE == 'NUMBER') {
      event.DATEFILTERLIST = FilterSearchOptions.numberCurrencyFilter(event.FILTERTYPE);
    }

    this._filterList = [event];
    this.addFilter.FILTERTYPE = event.FILTERTYPE;

    this.FILTERSLIST = this.userfilter.get('FILTERSLIST') as FormArray;
    this.FILTERSLIST.push(this.createOPFilter(event.FILTERTYPE));

    this.addFilter.OPERATION =
      event.FILTERTYPE == 'DATE'
        ? 'is in the last'
        : event.FILTERTYPE == 'CURRENCY' || event.FILTERTYPE == 'NUMBER'
          ? 'is equal to'
          : 'contains';
  }

  /**
   * This function is used to create the OP filter.
   * @param type -type of the filter
   * @returns -data of the filters
   */
  createOPFilter(type: any): FormGroup {
    return this._formBuilder.group({
      OPERATION:
        type == 'DATE'
          ? 'is in the last'
          : type == 'CURRENCY' || type == 'NUMBER'
            ? 'is equal to'
            : 'contains',
      VALUE: '',
      VALUE2: '',
      FILTERTYPE: type,
    });
  }

  /**
   * This function is used to apply the optional Date Filter.
   * @param event -event data
   * @param filterIs - filter data
   * @param val -val data
   * @param index -index data.
   */
  optionalDateFilter(event: any, filterIs: any, val: any, index: any) {
    filterIs.selectedFilter = event.value;
    this.selectedFilterIs = event.value;

    if (index != -1) {
      this.userfilter.controls.FILTERS['controls'][index].controls['VALUE'].reset();
      this.userfilter.controls.FILTERS['controls'][index].controls['VALUE2'].reset();
    }

    this.addFilter['VALUE'] = '';
    this.addFilter['VALUE2'] = '';
    this.cdf.markForCheck();
  }

  /**
   * This function is used to Adddynamic filter data.
   * @param IsfilterData -get the filter data flag
   * @param oprationalFilter -current filter data
   * @param evt -event data
   * @returns -newly added filters list.
   */
  async addfilter(IsfilterData: any, oprationalFilter: any, evt: any) {
    if (
      !this.TableColumnsService.checkValidation(
        this.addFilter.VALUE,
        this.addFilter.VALUE2,
        this.addFilter.OPERATION,
        IsfilterData.FILTERTYPE,
      )
    ) {
      evt.preventDefault();
      evt.stopPropagation();
      return false;
    }
    await this.addDynamicFilter(IsfilterData);

    let sIndex: any = this.optionalFilters.length - 1;

    this.userfilter.value.FILTERS[sIndex].VALUE = this.addFilter.VALUE;
    this.userfilter.value.FILTERS[sIndex].VALUE2 = this.addFilter.VALUE2;
    this.userfilter.value.FILTERS[sIndex].OPERATION = this.addFilter.OPERATION;
    this.userfilter.value.FILTERS[sIndex].FILTERTYPE = IsfilterData.FILTERTYPE;
    IsfilterData.AdvancedFilter = this.userfilter.value.FILTERS[sIndex];
    let advFilters: any = JSON.parse(localStorage.getItem('Users_Advance_Filter')!);
    if (advFilters) {
      this.saveAdvanceFilter = advFilters;
    }

    this.saveAdvanceFilter.push(IsfilterData);
    localStorage.setItem('Users_Advance_Filter', JSON.stringify(this.saveAdvanceFilter));

    if (this.FILTERS.length == 1) {
      this.userfilter.patchValue({
        FILTERS: [
          {
            OPERATION: this.addFilter.OPERATION,
            VALUE: this.addFilter.VALUE,
            VALUE2: this.addFilter.VALUE2,
            FILTERTYPE: IsfilterData.FILTERTYPE,
          },
        ],
      });
    } else {
      this.FILTERS.value.forEach((filterData: any, index: any) => {
        if (sIndex == index) {
          filterData = {
            OPERATION: this.addFilter.OPERATION,
            VALUE: this.addFilter.VALUE,
            VALUE2: this.addFilter.VALUE2,
            FILTERTYPE: IsfilterData.FILTERTYPE,
          };
        }
      });

      this.userfilter.patchValue({
        FILTERS: this.FILTERS.value,
      });
    }

    this.applayOptionalfilter(IsfilterData, sIndex, oprationalFilter);

    $('.example-containerdata').css(
      'height',
      $(window).height()! - ($('#filter-form-menu-wrap').height()! + 265) + 'px',
    );
    this.cdf.markForCheck();
  }

  /**
   * This function is used to apply the optional filter
   * @param FilterData -this function is used to filter the data.
   * @param isIndex -current index of the filter
   * @param OpretionIs -
   * @param evt -event data.
   * @param isDynamic -isdynamic flag data.
   * @returns -optional filter
   */
  applayOptionalfilter(
    FilterData: any,
    isIndex: any,
    OpretionIs?: any,
    evt?: any,
    isDynamic?: any,
  ) {
    if (isDynamic == 'isDynamic') {
      this.cdf.detectChanges();
    }
    let saveAdvancefilterData: any = JSON.parse(localStorage.getItem('Users_Advance_Filter')!);

    const field1Val: any =
      this.userfilter.controls.FILTERS['controls'][isIndex].controls['VALUE'].value;
    const field2Val: any =
      this.userfilter.controls.FILTERS['controls'][isIndex].controls['VALUE2'].value;
    const operationVal: any =
      this.userfilter.controls.FILTERS['controls'][isIndex].controls['OPERATION'].value;
    const filterTypeVal: any =
      this.userfilter.controls.FILTERS['controls'][isIndex].controls['FILTERTYPE'].value;

    if (
      !this.TableColumnsService.checkValidation(field1Val, field2Val, operationVal, filterTypeVal)
    ) {
      evt.preventDefault();
      evt.stopPropagation();
      return false;
    }

    let addData: any = JSON.parse(JSON.stringify(FilterData));
    addData.selectedFilter = OpretionIs.triggerValue;

    const applyFilterData: any = this.TableColumnsService.Optionalfilter(
      addData,
      isIndex,
      this.optionalDateFilterPayload,
      this.userfilter,
    );
    this.optionalDateFilterPayload = applyFilterData;

    if (saveAdvancefilterData) {
      if (!saveAdvancefilterData[isIndex]) {
        this.saveAdvanceFilter.push(FilterData);
        saveAdvancefilterData = saveAdvancefilterData.concat(this.saveAdvanceFilter[isIndex]);
      }

      saveAdvancefilterData[isIndex].AdvancedFilter.VALUE = field1Val;
      saveAdvancefilterData[isIndex].AdvancedFilter.VALUE2 = field2Val;
      saveAdvancefilterData[isIndex].AdvancedFilter.OPERATION = operationVal;
      saveAdvancefilterData[isIndex].AdvancedFilter.FILTERTYPE = filterTypeVal;

      saveAdvancefilterData[isIndex].FilterHeadings = applyFilterData[isIndex];
      localStorage.setItem('Users_Advance_Filter', JSON.stringify(saveAdvancefilterData));
    }
    this.doFilter(this.optionalDateFilterPayload);
    this.cdf.markForCheck();
  }

  enableMsSSOUser() {
    const payload: any = {
      Request: 'EnableMicrosoftSSOUser',
      UserGuid: this.currentUser.UserGuid,
    };
    this.callSsoApi(payload);
  }

  disableMsSSOUser() {
    const payload: any = {
      Request: 'DisableMicrosoftSSOUser',
      UserGuid: this.currentUser.UserGuid,
    };
    this.callSsoApi(payload);
  }

  enableMsSSOAllUsers() {
    const payload: any = {
      Request: 'EnableMicrosoftSSOAllUsers',
    };
    this.callSsoApi(payload);
  }

  disableMsSSOAllUsers() {
    const payload: any = {
      Request: 'DisableMicrosoftSSOAllUsers',
    };
    this.callSsoApi(payload);
  }

  callSsoApi(payload: any) {
    this._mainAPiServiceService
      .getSetData(payload, 'login')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          // console.log(response);
          this.cdf.markForCheck();
        },
        error: (error: any) => {
          this.toastr.error(error);
          this.cdf.markForCheck();
        },
      });
  }

  /**
   * This function is used to do the filter
   * @param mainFilter -filter data.
   */
  doFilter(mainFilter: any) {
    const payloadData: any = JSON.parse(JSON.stringify(mainFilter));
    const finalPayload: any = payloadData
      .filter((d: any) => d['value'] !== null)
      .map((e: any) => {
        if (e['value'] && e['value'] !== null) {
          delete e['value'].COLUMNID;
          return e['value'];
        }
      });
    const doFilter: any = JSON.parse(localStorage.getItem('users_filter')!);
    doFilter.AdvancedFilters = finalPayload;

    delete doFilter.activeDesc;
    delete doFilter.unbilledWorkDesc;
    delete doFilter.FILTERINDEX;
    delete doFilter.FILTERAPPLAY;

    this.reload(doFilter);
    this.cdf.markForCheck();
  }

  /**
   * This function is used to add the dynamic filter data.
   * @param event -dynamic data
   * @param type -type of the filter.
   */
  addDynamicFilter(event: any, type?: any) {
    if (event.FILTERTYPE == 'DATE') {
      event.DATEFILTERLIST = this.dateFilter;
      event.DATEINNETFILTER = [
        {
          id: 1,
          value: 'days',
        },
        {
          id: 2,
          value: 'months',
        },
      ];
    }

    if (
      event.FILTERTYPE !== 'DATE' &&
      event.FILTERTYPE !== 'CURRENCY' &&
      event.FILTERTYPE !== 'NUMBER'
    ) {
      event.DATEFILTERLIST = this.manullyOptionalFilter;
    }

    if (event.FILTERTYPE == 'CURRENCY' || event.FILTERTYPE == 'NUMBER') {
      event.DATEFILTERLIST = FilterSearchOptions.numberCurrencyFilter(event.FILTERTYPE);
    }

    event.FILTERAPPLY = true;
    if (!type) {
      this.optionalFilters.push(event);
    }
    // OPTIONAL FILTER
    this.FILTERS = this.userfilter.get('FILTERS') as FormArray;
    this.FILTERS.push(this.createOPFilter(event.FILTERTYPE));
    this.cdf.markForCheck();
  }

  /**
   * This function is used to clear the filter.
   * @param name -name of the filter
   * @param filterBy -type of the filter
   */
  clearFilter(name: any, filterBy: any) {
    delete this.activeFilters[name];
    this.activeFilters ? JSON.parse(localStorage.getItem('Users_config')!) : {};
    let resetFilter: any = JSON.parse(localStorage.getItem('users_filter')!);
    this.clearFilters = true;
    if (filterBy == 'Active') {
      this.userfilter.controls['ACTIVE'].setValue(1);
      this.activeFilters.active = 1;
      this.activeFilters.activeDesc = 'Active Users';
      resetFilter.ACTIVE = 1;
    }

    if (filterBy == 'Search') {
      this.userfilter.controls['searchFilter'].setValue('');
      resetFilter.Search = '';
      this.activeFilters.Search = '';
    }
    localStorage.setItem('users_filter', JSON.stringify(resetFilter));
    localStorage.setItem('Users_config', JSON.stringify(this.activeFilters));
    this.addOptionalFilter(resetFilter);
    this.cdf.markForCheck();
  }

  /**
   * This function is used to check the filter config.
   */
  Filterconfig(activefilter: any, filterBy: any): void {
    if (filterBy == 'Active') {
      this.activeFilters.active = activefilter.id;
      this.activeFilters.activeDesc = activefilter.name;
    }
    localStorage.setItem('Users_config', JSON.stringify(this.activeFilters));
    this.cdf.markForCheck();
  }

  /**
   * This function is used to set the default advanced filter
   */
  async setDefaultAdvanceFilter() {
    let advanceFiltes: any = JSON.parse(localStorage.getItem('Users_Advance_Filter')!);
    if (advanceFiltes) {
      this.optionalDateFilterPayload = [];
      this.optionalFilters = advanceFiltes;
      await advanceFiltes.forEach(async (filterData: any, index: any) => {
        await this.addDynamicFilter(filterData.AdvancedFilter, 'default');

        this.FILTERS.value[index].OPERATION = await filterData.AdvancedFilter.OPERATION;
        this.FILTERS.value[index].FILTERTYPE = await filterData.AdvancedFilter.FILTERTYPE;
        this.FILTERS.value[index].VALUE = await filterData.AdvancedFilter.VALUE;
        this.FILTERS.value[index].VALUE2 = await filterData.AdvancedFilter.VALUE2;
        await this.optionalDateFilterPayload.push(filterData.FilterHeadings);

        await this.userfilter.patchValue({
          FILTERS: this.FILTERS.value,
        });
      });
      this.cdf.markForCheck();
    }
  }

  /**
   * This function is used to reset the optional filter.
   * @param event -event data
   * @param type -type of the filter.
   * @param isindex -is index flag.
   */
  resetOptionalFilter(event: any, type: any, isindex: any): void {
    let index: any = this.optionalFilters.findIndex((e: any) => e.COLUMNID == event.COLUMNID);

    event.FILTERAPPLY = false;

    setTimeout(() => {
      this.optionalFilterList.map((x: any) => {
        if (this.optionalFilters.findIndex((e: any) => x.COLUMNID == event.COLUMNID) !== -1) {
          x.FILTERAPPLY = false;
        }
      });
      this.cdf.markForCheck();
    }, 100);

    this.optionalFilters[isindex]['FILTERAPPLY'] = false;

    this.saveAdvanceFilter.splice(index, 1);
    this.optionalFilters.splice(index, 1);
    this.optionalDateFilterPayload.splice(isindex, 1);
    this.FILTERS.controls.splice(isindex, 1);
    this.userfilter.value.FILTERS.splice(isindex, 1);

    const resetFilter: any = JSON.parse(localStorage.getItem('users_filter')!);

    delete resetFilter.activeDesc;
    delete resetFilter.unbilledWorkDesc;
    delete resetFilter.FILTERINDEX;
    delete resetFilter.FILTERAPPLAY;

    const ArrayResetOptional: any = JSON.parse(JSON.stringify(this.userfilter.value.FILTERS));

    this.TableColumnsService.refrshAdvanceFilter(event, 'Users');
    const ArrayResetOptionalNew: any = ArrayResetOptional.map((data: any, index: any) => {
      if (this.optionalFilters[index]) {
        data.COLUMNNAME = this.optionalFilters[index].COLUMNNAME;
      }
      return data;
    });

    const finalPayload: any = ArrayResetOptionalNew.filter(
      (d: any) => d['VALUE'] !== null && d['VALUE'] !== '',
    ).map((e: any) => {
      if (e['VALUE'] && e['VALUE'] !== '') {
        delete e.COLUMNID;

        if (e.FILTERTYPE == 'DATE') {
          let date1: any = e && e.VALUE !== '' ? moment(e.VALUE).format('DD/MM/YYYY') : '';
          let date2: any =
            e && e.VALUE2 !== '' && e.OPERATION == 'is between'
              ? moment(e.VALUE2).format('DD/MM/YYYY')
              : '';

          if (e.OPERATION == 'is in the last') {
            e.VALUE = e.VALUE;
            e.VALUE2 = e.VALUE2;
          } else {
            e.VALUE = date1;
            e.VALUE2 = date2;
          }
        }

        if (e.VALUE2 == null) {
          e.VALUE2 = '';
        }

        // e.COLUMNNAME = event.COLUMNNAME;
        // e.COLUMNNAME = ArrayResetOptionalNew[localIndex].COLUMNNAME
        return e;
      }
    });

    const advanceFilterPayload: any = this.TableColumnsService.loadAdvanceFilterPayload('Users');
    resetFilter.AdvancedFilters =
      finalPayload.length !== 0 ? finalPayload : advanceFilterPayload ? advanceFilterPayload : [];

    if (resetFilter.AdvancedFilters.length == 0) {
      delete resetFilter.AdvancedFilters;
      localStorage.removeItem('Users_Advance_Filter');
    }
    // const finalBasicPayload = JSON.parse(JSON.stringify(resetFilter));

    // delete finalBasicPayload.DateRange;
    // delete finalBasicPayload.dayRange;
    // resetFilter.FILTERS = finalPayload;
    resetFilter.AdvancedFilters = finalPayload;
    if (this.FILTERS.controls.length == 0 || finalPayload.length == 0) {
      // delete resetFilter.FILTERS;
      delete resetFilter.AdvancedFilters;
    }

    this.reload(resetFilter);
    this.cdf.markForCheck();
    // this.reload(finalBasicPayload);
  }

  /**
   * This function is used to check the filter ui.
   * @param filter
   * @param index
   */
  setFilterUi(filter: any, index: any): void {
    this.selectedFilterIs = this.optionalDateFilterPayload[index]['value']['OPERATION'];
    this.cdf.markForCheck();
  }

  /**
   * This function is used to check the routing.
   */
  nameFunction(): void {
    if (this.router.url == '/users/useractivity') {
      // this.clickbtn = "UserActivity";
      this.location.replaceState('/users/useractivity');
      this.behaviorService.setUserMenuName('userActivity');
      setTimeout(() => {
        this.behaviorService.setactiveTab(33);
        this.cdf.markForCheck();
      }, 320);
    } else if (this.router.url == '/users/loggedon-user') {
      // this.clickbtn = "LoggedOnUser";
      this.location.replaceState('/users/loggedon-user');
      this.behaviorService.setUserMenuName('loggedOnUser');
    } else if (this.router.url == '/users') {
      // this.clickbtn = "ExportToSLQ";

      this.location.replaceState('/users');
      this.behaviorService.setUserMenuName(null);
    }
    this.cdf.markForCheck();
  }

  /**
   * This function is used to open the user dialog data.
   * @param actionType -this function is used to check the action type.
   * @returns -
   */
  userDialog(actionType: any): boolean | void {
    this.toolbarServiceService.SetOldistrackid('open');
    let popupData: any = {};
    if (actionType == 'new') {
      popupData = { action: actionType };
    } else if (actionType == 'edit' || actionType == 'duplicate') {
      let ActiveUserData: any = JSON.parse(localStorage.getItem('current_user_Data')!);
      if (!ActiveUserData) {
        this.toastr.error('Please Select User');
        return false;
      }
      popupData = {
        action: actionType,
        USERGUID: ActiveUserData.USERGUID,
        USERID: ActiveUserData.USERID,
        USERNAME: ActiveUserData.USERNAME,
      };
    }
    const dialogRef = this._matDialog.open(UserDialogComponent, {
      disableClose: true,
      panelClass: 'User-dialog',
      data: popupData,
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (result: any) => {
          this.toolbarServiceService.SetOldistrackid('close');
          if (result) {
            $('#refreshUser').click();
          }
          this.cdf.markForCheck();
        },
        error: (error: any) => {
          this.cdf.markForCheck();
        },
      });
  }

  /**
   * This function is used to delete User
   */
  DeleteUser(): void {
    this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
      disableClose: true,
      width: DIALOG_WIDTH.FULL,
    });
    this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete?';
    this.confirmDialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (result: any) => {
          if (result) {
            let ActiveUserData: any = JSON.parse(localStorage.getItem('current_user_Data')!);
            let postData: any = {
              Action: 'delete',
              data: { USERGUID: ActiveUserData.USERGUID },
            };
            let RefreshIdArray: any = ['#refreshUser'];
            this.toolbarServiceService.SetVariableForRetry(postData, 'user', RefreshIdArray);
            this._mainAPiServiceService
              .getSetData(postData, 'user')
              .pipe(takeUntil(this._unsubscribeAll$))
              .subscribe({
                next: (res: any) => {
                  if (res.STATUS == 'success' && res.CODE == 200) {
                    localStorage.setItem('istrackid', this.oldIsTrackId);
                    $('#refreshUser').click();
                    this.toastr.success('Deleted successfully');
                  } else if (res.CODE == 451 && res.STATUS == 'warning') {
                    this.checkValidation(res.DATA.VALIDATIONS, postData, 'user');
                  } else if (res.CODE == 450 && res.STATUS == 'error') {
                    this.checkValidation(res.DATA.VALIDATIONS, postData, 'user');
                  } else if (res.MESSAGE == 'Not logged in') {
                    // this.dialogRef.close(false);
                  }
                  this.cdf.markForCheck();
                },
                error: (err: any) => {
                  this.toastr.error(err);
                  this.cdf.markForCheck();
                },
              });
          }
          this.cdf.markForCheck();
        },
        error: (error: any) => {
          this.cdf.markForCheck();
        },
      });
  }

  /**
   * This function is used to check the validation data.
   * @param bodyData -validation data.
   * @param details -validation details.
   * @param ApiName -Api name.
   */
  checkValidation(bodyData: any, details: any, ApiName: any): void {
    let errorData: any = [];
    let warningData: any = [];
    let tempError: any = [];
    let tempWarning: any = [];
    bodyData.forEach((value: any) => {
      if (value.VALUEVALID == 'No' || value.VALUEVALID == 'NO' || value.VALUEVALID == 'Error') {
        errorData.push(value.ERRORDESCRIPTION);
        tempError[value.FIELDNAME] = value;
      } else if (value.VALUEVALID == 'Warning') {
        tempWarning[value.FIELDNAME] = value;
        warningData.push(value.ERRORDESCRIPTION);
      }
    });

    if (Object.keys(errorData).length != 0) {
      localStorage.setItem('confEWshow', 'error');
      this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
        disableClose: true,
        width: DIALOG_WIDTH.FULL,
        data: {
          errorData: errorData,
        },
      });
      this.confirmDialogRef.componentInstance.confirmMessage = '';
      this.confirmDialogRef
        .afterClosed()
        .pipe(takeUntil(this._unsubscribeAll$))
        .subscribe({
          next: (result: any) => {
            localStorage.removeItem('confEWshow');
            this.confirmDialogRef = null;
            this.cdf.markForCheck();
          },
          error: (error: any) => {
            this.cdf.markForCheck();
          },
        });
    } else if (Object.keys(warningData).length != 0) {
      localStorage.setItem('confEWshow', 'warning');
      this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
        disableClose: true,
        width: DIALOG_WIDTH.FULL,
        // data: {warningValidation:warningData},
        data: warningData,
      });
      this.confirmDialogRef.componentInstance.confirmMessage =
        ApiName === 'SetInvoice' ? '' : 'Are you sure you want to delete?';
      // this.confirmDialogRef.componentInstance.confirmMessage = (ApiName === 'SetInvoice') ? '' : warningData;
      this.confirmDialogRef
        .afterClosed()
        .pipe(takeUntil(this._unsubscribeAll$))
        .subscribe({
          next: (result: any) => {
            localStorage.removeItem('confEWshow');
            if (result) {
              this.toolbarServiceService.DeleteGData(details, ApiName);
            }
            this.confirmDialogRef = null;
            this.cdf.markForCheck();
          },
          error: (error: any) => {
            this.cdf.markForCheck();
          },
        });
    } else if (Object.keys(warningData).length == 0 && Object.keys(errorData).length == 0) {
      this.toolbarServiceService.DeleteGData(details, ApiName);
      this.cdf.markForCheck();
    }
  }

  /**
   * This function is used to open the loged on users popup.
   */
  showUserLoggedOnPopup(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '500px';
    const dialogRef = this._matDialog.open(LoggedonUserComponent, dialogConfig);

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (result: any) => {
          this.cdf.markForCheck();
        },
        error: (error: any) => {
          this.cdf.markForCheck();
        },
      });
  }
}
